import { useHedgeModeSelector } from "@shared/features/configuration/AccountConfiguration/hooks";
import Select from "common/Select/Select";
import React from "react";
import { FormFieldTitle } from "features/bots/common/styles";
import { StyledCard } from "features/configuration/accounts/AccountConfigurationDrawer/AccountConfiguration/styles";
import Text from "common/Typography/Text";
import { translateOptionName } from "@shared/common/i18n/optionNames";

const HedgeModeSelector = () => {
  const { hedgeModeSelectorData, isPreview } = useHedgeModeSelector();

  const select = (
    <Select
      value={hedgeModeSelectorData.value}
      onChange={hedgeModeSelectorData.onChange}
      options={hedgeModeSelectorData.options?.map((option) => ({
        value: option.value,
        label: translateOptionName(option.name),
      }))}
      bordered={isPreview ?? false}
      style={isPreview ? { width: "100%" } : undefined}
      disabled={isPreview}
      popupMatchSelectWidth={false}
      mobileTitle={hedgeModeSelectorData.title}
    />
  );

  if (!isPreview) {
    return (
      <StyledCard>
        <Text type="secondary">{hedgeModeSelectorData.title}</Text>
        {select}
      </StyledCard>
    );
  }

  return (
    <div>
      <FormFieldTitle>{hedgeModeSelectorData.title}</FormFieldTitle>
      {select}
    </div>
  );
};

export default HedgeModeSelector;
